export default __webpack_public_path__ + "static/media/photo-placeholder.24ecee72.svg";